export default __webpack_public_path__ + "static/screeny-55-gp-xs-4-cd62405774dfadcf696e1444874f9ed4.jpg";